var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formValidate",
      attrs: {
        model: _vm.params,
        "label-position": "right",
        "label-width": "180px",
        rules: _vm.rules
      }
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "dstName", label: _vm.$t("dstConfig.dstName") } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  false
                    ? _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.params.id,
                          callback: function($$v) {
                            _vm.$set(_vm.params, "id", $$v)
                          },
                          expression: "params.id"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("dstConfig.dstNameRequire")
                    },
                    model: {
                      value: _vm.params.dstName,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "dstName", $$v)
                      },
                      expression: "params.dstName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "timezone", label: _vm.$t("dstConfig.timezone") } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("dstConfig.timezoneRequire")
                    },
                    model: {
                      value: _vm.params.timezone,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "timezone", $$v)
                      },
                      expression: "params.timezone"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "startTime", label: _vm.$t("dstConfig.startTime") } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: _vm.$t("dstConfig.startTimeRequire"),
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss"
                    },
                    model: {
                      value: _vm.params.startTime,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "startTime", $$v)
                      },
                      expression: "params.startTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "endTime", label: _vm.$t("dstConfig.endTime") } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: _vm.$t("dstConfig.endTimeRequire"),
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss"
                    },
                    model: {
                      value: _vm.params.endTime,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "endTime", $$v)
                      },
                      expression: "params.endTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "startYear", label: _vm.$t("dstConfig.startYear") } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: _vm.$t("dstConfig.startYearRequire")
                    },
                    model: {
                      value: _vm.params.startYear,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "startYear", $$v)
                      },
                      expression: "params.startYear"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "endYear", label: _vm.$t("dstConfig.endYear") } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: _vm.$t("dstConfig.endYearRequire")
                    },
                    model: {
                      value: _vm.params.endYear,
                      callback: function($$v) {
                        _vm.$set(_vm.params, "endYear", $$v)
                      },
                      expression: "params.endYear"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 2, align: "center" } },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "right",
                        width: "282",
                        trigger: "hover"
                      }
                    },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("dstConfig.endTimeDesc")))
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "el-icon-question icon_tips_cla",
                        attrs: { slot: "reference" },
                        slot: "reference"
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "active", label: _vm.$t("dstConfig.active") } },
        [
          _c(
            "el-radio",
            {
              attrs: { label: 1 },
              model: {
                value: _vm.params.active,
                callback: function($$v) {
                  _vm.$set(_vm.params, "active", $$v)
                },
                expression: "params.active"
              }
            },
            [_vm._v(_vm._s(_vm.$t("device.enableStatus")))]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: 0 },
              model: {
                value: _vm.params.active,
                callback: function($$v) {
                  _vm.$set(_vm.params, "active", $$v)
                },
                expression: "params.active"
              }
            },
            [_vm._v(_vm._s(_vm.$t("device.disbaleDevice")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f607e116", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f607e116","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/dstSaveOrUpdate/src/main.vue
// module id = null
// module chunks = 